var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 14H15.5C14.8372 14.0007 14.2017 14.2643 13.733 14.733C13.2643 15.2017 13.0007 15.8372 13 16.5V21.5H15.5V16.5H65.5V49H30.5V51.5H35.5V54H33V56.5H48V54H45.5V51.5H65.5C66.1628 51.4993 66.7983 51.2357 67.267 50.767C67.7357 50.2983 67.9993 49.6628 68 49V16.5C67.9993 15.8372 67.7357 15.2017 67.267 14.733C66.7983 14.2643 66.1628 14.0007 65.5 14ZM43 54H38V51.5H43V54ZM26.125 24H9.875C9.37792 24.0007 8.90139 24.1984 8.54991 24.5499C8.19842 24.9014 8.00066 25.3779 8 25.875V59.625C8.00066 60.1221 8.19842 60.5986 8.54991 60.9501C8.90139 61.3016 9.37792 61.4993 9.875 61.5H26.125C26.6221 61.4993 27.0986 61.3016 27.4501 60.9501C27.8016 60.5986 27.9993 60.1221 28 59.625V25.875C27.9993 25.3779 27.8016 24.9014 27.4501 24.5499C27.0986 24.1984 26.6221 24.0007 26.125 24ZM25.5 59H10.5V26.5H25.5V59ZM23 31.5H13V29H23V31.5ZM23 36.5H13V34H23V36.5ZM23 41.5H13V39H23V41.5ZM20.5 44H23V46.5H20.5V44Z",
    fill: "url(#paint0_linear_4132_28645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4132_28645",
    x1: 10.2649,
    y1: 12.7212,
    x2: 51.9365,
    y2: 72.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCard2);
export default __webpack_public_path__ + "static/media/auto_card2.2edc502618bcb7e3dab8014b2d613da1.svg";
export { ForwardRef as ReactComponent };